import { useQuery } from "@tanstack/react-query"
import { api } from "../../../lib/api/client"
import { contactOverviewKeys } from "../../../lib/query-keys"
import type { ContactOverview } from "../types"

// Re-export for backward compatibility
export { contactOverviewKeys }

/**
 * Hook to fetch a contact's overview data including the contact,
 * associated matters, and last note.
 *
 * @param contactId - The contact ID to fetch overview for
 * @returns Query result with contact overview data
 */
export function useContactOverview(contactId: string) {
  return useQuery({
    queryKey: contactOverviewKeys.detail(contactId),
    queryFn: () => api.contacts.overview(contactId),
    enabled: !!contactId,
    select: (response): ContactOverview => ({
      contact: response.data.contact,
      matters: response.data.matters ?? [],
      lastNote: response.data.lastNote ?? null,
    }),
  })
}
